import {FC} from 'react'
import {Col, Row} from 'react-bootstrap'
import Skeleton from 'react-loading-skeleton'

const SkeletonInput = () => {
  return (
    <div style={{display: 'flex', width: '100%', flexDirection: 'column', gap: '0.5rem'}}>
      <div style={{width: '50%'}}>
        <Skeleton count={1} height={30} />
      </div>
      <div style={{width: '100%'}}>
        <Skeleton count={1} height={46} />
      </div>
    </div>
  )
}

/** @deprecated use <SkeletonPageDetail /> instead */
export const SkeletonOrderDetail: FC = () => {
  return (
    <div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '2rem'}}>
        {Array.from({length: 8}).map((_, idx) => (
          <Row key={idx}>
            {Array.from({length: 2}).map((_, i) => (
              <Col md={6} key={i}>
                <SkeletonInput />
              </Col>
            ))}
          </Row>
        ))}
      </div>
    </div>
  )
}
